<style scoped>
.contet_title {
  font-size: 22px;
  padding-top: 25px;
  padding-bottom: 20px;
  text-align: center;
  font-weight: bold;
}
.content--box {
  padding: 15px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <div class="contet_title">
      {{ title }}
    </div>
    <div class="content--box">
      <div
        style="
          font-family: Consolas, 'Courier New', monospace;
          line-height: 19px;
        "
      >
        <div
          style="
            font-family: Consolas, 'Courier New', monospace;
            line-height: 19px;
          "
        >
          <div>
            &nbsp;为规范网络食品交易行为，美滋来外卖发现入网食品生产经营者有下列严重违法行为之一的，将停止向其提供网络交易平台服务:
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            1、入网食品生产经营者因涉嫌食品安全犯罪被立案侦查或者提起公诉的;
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            2、入网食品生产经营者因食品安全相关犯罪被人民法院判处刑罚的;
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            3、入网食品生产经营者因食品安全违法行为被公安机关拘留或者给予其他治安管理处罚的;
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            4、入网食品生产经营者被食品药品监督管理部门依法作出吊销许可证、责令停产停业等处罚;
          </div>
          <div>&nbsp; &nbsp; &nbsp; 一、个人卫生</div>
          <div>
            &nbsp; &nbsp; &nbsp; 1、员工每年必须进行预防性的身体健康检查。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            2、员工必须先取得健康证并经培训合格后方可上岗工作。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            3、健康检查的“五病”包括病毒性肝炎，痢疾，伤寒，活动性肺结核，化脓性或渗出性皮肤病。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            4、为防止食品污染，保障食品安全卫生，员工应养成经常洗手的好习惯，工作中途离开岗位再上岗，休息后再次返回岗位必须坚持洗净手再工作的原则。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            5、员工要养成良好的个人卫生习惯，坚持“四勤”，即勤洗手，剪指甲;勤洗澡，理发:勤洗衣服，被褥:勤换工作服。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            6、员工如发生原因不明腹泻，发烧，咳嗽和皮肤伤口感染时，必须立即去医院就医，病愈后方可上班，不能边上班边看病。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            7、员工的工作服必须定期清洗，并不得穿戴工作服出入非工作场所。
          </div>
          <div>&nbsp; &nbsp; &nbsp; 8、员工开始工作前必须坚持洗手消毒。</div>
          <div>&nbsp; &nbsp; &nbsp; 二、食品包装及容器卫生</div>
          <div>
            &nbsp; &nbsp; &nbsp;
            1、食品的容器要用国家允许的材料制成，并符合有关国家标准，无毒无害。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            2、食品包装标识必须清楚，容易辨识，必须有中文标识，标识的内容包括品名，产地，厂名，生产日期，生产批号或者代号，规格，配方或主要成分，保质期限等。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            3、定型包装食品和食品添加剂的产品说明书，不得有夸大或者虚假的宣传内容
          </div>
          <div>&nbsp; &nbsp; &nbsp; 三、工作场所卫生</div>
          <div>
            &nbsp; &nbsp; &nbsp;
            1、墙壁、天花板、门窗保持清洁，无蜘蛛网、霉斑及明显积垢。
          </div>
          <div>&nbsp; &nbsp; &nbsp; 2、送餐设备清洁油污、积垢、摆放整齐。</div>
          <div>&nbsp; &nbsp; &nbsp; 四、预防食物中毒</div>
          <div>
            &nbsp; &nbsp; &nbsp;
            1、食物中毒的种类，主要分为细菌性食物中毒，真菌性食物中毒，化学性食物中毒和有毒动植物食物中毒。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            2、苏丹红是一种工业染料，可以严重危害人体健康，不能作为食品添加剂使用。
          </div>
          <div>&nbsp; &nbsp; &nbsp; 3、细菌性食物中毒多发生在夏秋季节。</div>
          <div>
            &nbsp; &nbsp; &nbsp; 4、沙门氏菌食物中毒多由动物性食品引起。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            5、副溶血性弧菌食物中毒多发生在高温季节，多数由海(水)产品引起。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            6、甲醛(主要成分福尔马林)是一种化学物质，目前被广泛应用于医学和工业等领域。人体呼吸道吸入和食入过量都会对身体造成危害，因此，严禁在食品的加工和保存中使用，以及在居家装修和家具中过量使用。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            7、黄曲霉毒素主要污染的食品有花生，玉米，干果类等。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            8、大豆中含有有毒物质抗胰蛋白酶和凝血素，生食容易发生食物中毒。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            9、常见的化学性食物中毒有:有机磷农药中毒，砷化物食物中毒，亚硝酸盐食物中毒等。发生食物中毒的单位，除采取抢救措施外，还必须及时向所在地食品药品监督部门报告。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            10、大豆中含红细胞凝集素和蛋白酶抑制剂，因此豆浆一定要煮沸10分钟以上以免发生食物中毒。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            11、食品从业人员发现有食物中毒情况发生时，应立即停止销售可疑食物，拨打120抢救病人，保留可疑食物，然后报告食品药品监督部门。
          </div>
          <div>&nbsp; &nbsp; &nbsp; 五、送餐过程食品安全注意事项</div>
          <div>
            &nbsp; &nbsp; &nbsp;
            1、送餐员在日常工作中确保自己运输的食品不发生变质。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            2、送餐时注意地址是否相符，餐厅证照是否齐全，并随手拍照上传，做到让消费者放心，同时也便于监管部门与平台的监管。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp;
            3、配送箱要清洁、专用、膳食不得与有毒有害物品、待加工食品、食品原料存放于同一配送箱内。
          </div>
          <div>
            &nbsp; &nbsp; &nbsp; 4、配送箱要采取密闭措施，防止灰尘、雨水等污染。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
  created() {
    this.title = this.$route.query.data;
  },
  methods: {},
};
</script>
